<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>小燕鷗保育</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <p>每年 4~8 月，台灣都會迎接一群來自澳洲等地的嬌客飛到桃園、台中、宜蘭、花蓮和澎湖沿海繁殖渡冬，牠們就是二級海洋保育類野生動物「小燕鷗」。2024 年花蓮縣野鳥學會在和平電廠旁的堤外海灘，記錄到了 126 巢可愛的小燕鷗，顛覆一般人認為工業區附近生態環境不會好的印象，可能因為電廠設施的阻隔而讓外部干擾減少，又近鄰和平溪口而有淡水及食物來源，意外造就其良好的棲地環境。</p>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="sectTit">鄰近海灘發現成長中的小燕鷗</div>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer2-1">
              <!-- <div class="imgTit">由宜蘭縣野鳥學會提供</div> -->
            </div>
          </div>
          <div class="right">
            <div class="imgContainer2-2">
              <!-- <div class="imgTit">由宜蘭縣野鳥學會提供</div> -->
            </div>
            <div class="imgContainer2-3"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="sectTit">和平歡迎你 - 小燕鷗保育計畫</div>
        <p>2024 年，小燕鷗首度被記錄出現在和平電廠旁的堤外海灘築巢育雛後，和平電力隨即與花蓮縣野鳥學會共同啟動保育行動，同時展開為期三年的監測計畫。在悉心守護之下，2025 年繁殖巢位數自 126 巢提升至 218 巢，繁殖成功數也由 59 巢增加至 107 巢。</p>
        <br>
        <div class="sternula">
          <div class="item" v-for="(row, idx) in sternula" :key="idx">
            <div class="thumbnail" :style="setThumbnail(row.thumbnail)">
              <div class="tit">{{row.tit}}</div>
            </div>            
            <div class="desp">{{row.desp}}</div>
          </div>
          <div class="item">
            <div class="thumbnail icon1">
              <img src="@/assets/socialConservation/pic3_icon1.png" alt="" />
            </div>
          </div>
        </div>
        <swiper
          :modules = "modules"
          :slides-per-view="1"
          :space-between="1"
          :autoplay="{delay:3000, disableOnInteraction:false}"
          :speed="1000"
          :loop="true"
          :pagination="{clickable:true}"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          class="swiper"
        >
          <swiper-slide class="cover cover1"></swiper-slide>
          <swiper-slide class="cover cover2"></swiper-slide>
          <swiper-slide class="cover cover3"></swiper-slide>
          <swiper-slide class="cover cover4"></swiper-slide>
          <swiper-slide class="cover cover5"></swiper-slide>
          <swiper-slide class="cover cover6"></swiper-slide>
        </swiper>
        <br>
        <div class="divLine"></div>
      </div>
    </section>
    <section class="sect4">
      <div class="ctx">
        <div class="left">
          <p>小燕鷗為海岸生態系重要的生物之一，僅在距離海岸約 1 公里內覓食，由於體型較其他海鳥更小，在捕食魚類的同時，也是猛禽夏季重要食物來源，因此，在河口與海洋間生態能量的交換中扮演重要角色。</p>
          <div class="desp">
            <div class="tit"><i class="fa-solid fa-ellipsis-vertical"></i><i class="fa-solid fa-ellipsis-vertical"></i> 回饋分享</div>
            「起初認為鳥類都在樹上孵育雛鳥，原來小燕鷗是在海灘上啊！也因此了解海灘棲地面臨到人為干擾、流浪狗與車輛等威脅」。<small>（參與學員－江媽媽）</small>
          </div>
        </div>
        <div class="right">
          <img class="imgContainer4-1" src="@/assets/socialConservation/pic4_01.png" />
          <img class="imgContainer4-2" src="@/assets/socialConservation/pic4_02.png" />
        </div>
        <div class="clear"></div>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/6vBYVCow2m4?si=hmWcofR82ZJ10OEH" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default defineComponent({
  name: 'SocialConservation',
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide
  },
  setup() {
    const onSwiper = (swiper: any) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay]
    };
  },
  data() {
    return {
      sternula: [
        {
          tit: "水泥誘鳥",
          desp: "利用水泥抗風抗雨的特性，台泥水泥工作坊製作了小燕鷗水泥誘鳥，有助於吸引小燕鷗駐足棲息。",
          thumbnail: "pic3_01.webp"
        },
        {
          tit: "成立巡守隊",
          desp: "攜手和平港及供應商夥伴共同成立巡守隊，每年 4 月到 8 月定期巡查棲地、勸導釣客，守護小燕鷗的誕生與成長。",
          thumbnail: "pic3_02.webp"
        },
        {
          tit: "小學保育推廣",
          desp: "進入花蓮、南澳地區小學舉行小燕鷗保育推廣課程，讓學童認識生活環境周遭鳥類與棲地生態資源。",
          thumbnail: "pic3_03.webp"
        },
        {
          tit: "現地觀察",
          desp: "由鳥會老師帶領，透過望遠鏡實地觀察這小燕鷗，讓大家了解棲地保護的重要，如此才能讓小燕鷗安全地在這裡繁衍後代。",
          thumbnail: "pic3_04.webp"
        },
        {
          tit: "設置告示牌",
          desp: "海灘設置告示牌，宣導釣客村民減少干擾。",
          thumbnail: "pic3_05.webp"
        }
      ]
    }
  },
  methods:{
    setThumbnail: function(thumbnail: string) {
      return {
        background: `url(${require(`@/assets/socialConservation/${thumbnail}`)}) center`,
        backgroundSize: "cover"
      }
    }
  },
  mounted() {
    // let swiperPageination = (document.querySelector(".swiper-pagination") as HTMLElement).cloneNode(true);
    // (document.querySelector(".swiper") as HTMLElement).after(swiperPageination);    

    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-1") as HTMLElement, 1);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-2") as HTMLElement, 0.74);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-3") as HTMLElement, 0.74);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover2") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover3") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover4") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover5") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover6") as HTMLElement, 0.55);
    document.querySelectorAll(".sternula .thumbnail").forEach( (elem) => {
      new ImgContainerAutoResize(elem as HTMLElement, 0.65);
    });
    // new ImgContainerAutoResize(document.querySelector(".imgContainer4-1") as HTMLElement, 0.8);
    new ImgContainerAutoResize(document.querySelector(".sect4 iframe") as HTMLElement, 0.5625);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/socialConservation/kv.webp");
  background-position: center, center bottom;
  background-size: cover, cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 p {
  line-height: 2em;
}

.sect2 {
  background: url("@/assets/socialConservation/sectBack2.png");
  background-size: cover;
}

.sect2 .sectTit {
  width: 580px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #63BFAA;
  background: #F4F3F3;
}

.sect2 .gallery {
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: 30px;
}

.sect2 .gallery .left {
  flex: 0 0 59.5%;
}

.sect2 .gallery .right {
  flex: 0 0 40%;
}

.sect2 .gallery .left .imgContainer2-1 {
  width: 100%;
  position: relative;
  background: url(@/assets/socialConservation/pic2_01.jpg) center;
  background-size: cover;
}

.sect2 .gallery .right .imgContainer2-2 {
  width: 100%;
  margin: 0 0 5px;
  position: relative;
  background: url(@/assets/socialConservation/pic2_02.jpg) center;
  background-size: cover;
}

.sect2 .gallery .right .imgContainer2-3 {
  width: 100%;
  background: url(@/assets/socialConservation/pic2_03.jpg) center;
  background-size: cover;
}

.sect2 .gallery .left  .imgContainer2-1 .imgTit,
.sect2 .gallery .right .imgContainer2-2 .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}


.sect3 {
  background: #FDF8E4;
}

.sect3 .sectTit {
  margin: 0 0 20px;
  text-align: center;
  font-size: 36px;
  color: #0C5F99;
}

.sect3 p {
  line-height: 2em;
}

 .sect3 .sternula {
  margin: 0 0 20px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 3.5%;
}

.sect3 .sternula .item {
  flex: 0 0 31%;
  margin: 0 0 20px;
  overflow: hidden;
}



/* .sect3 .sternula .item .announce {
  display: inline-block;
  margin: 10px 0 0;
  padding: 10px 0 0;
  border-top: solid 1px #0c5f99;
  font-size: 24px;
  color: #0c5f99;
} */

.sect3 .sternula .item .thumbnail {
  position: relative;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.sect3 .sternula .item .thumbnail.icon1 {
}

.sect3 .sternula .item .thumbnail.icon1 img {
  width: 60%;
  margin: auto;
  display: block;
}

.sect3 .sternula .item .thumbnail .tit {
  width: 150px;
  margin: auto;
  padding: 0 10px 1px;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 10px 10px 0 0;
  text-align: center;
  font-size: 20px;
  color: #fff;
  background: #E99776;
}

.sect3 .sternula .item .desp {
  padding: 5px 0;
  line-height: 1.8em;
  font-size: 16px;
}

.sect3 .swiper {
  border-radius: 30px;
}

.sect3 .swiper .swiper-wrapper {
  /* overflow: hidden; */
}

.sect3 .swiper .cover1 {
    background: url(../../assets/socialConservation/carousel3_01.webp) center;
    background-size: cover;
}

.sect3 .swiper .cover2 {
    background: url(../../assets/socialConservation/carousel3_02.webp) center;
    background-size: cover;
}

.sect3 .swiper .cover3 {
    background: url(../../assets/socialConservation/carousel3_03.webp) center;
    background-size: cover;
}

.sect3 .swiper .cover4 {
    background: url(../../assets/socialConservation/carousel3_04.webp) center;
    background-size: cover;
}

.sect3 .swiper .cover5 {
    background: url(../../assets/socialConservation/carousel3_05.webp) center;
    background-size: cover;
}

.sect3 .swiper .cover6 {
    background: url(../../assets/socialConservation/carousel3_06.webp) center;
    background-size: cover;
}

.sect3 .swiper .swiper-pagination {
  /* bottom: -40px !important; */
}

.sect3 .swiper .swiper-pagination .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border: solid 1px #fff;
  background: #404040;
  opacity: 0.8;
}

.sect3 .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fff;
}

/* .swiper-button-next:after {
  padding: 10px;
  font-size: 60px;
  background: #00000088;
} */



.sect3 .divLine {
  border-bottom: dotted 2px #c0c0c0;
  transform: translateY(30px);
}

.sect4 {
  background: radial-gradient(circle at 50% 25%, #FDF8E4, #FDF8E4 70%, #ffffff00 70.1%);
}

.sect4 p {
  margin: 0;
  line-height: 2em;
}

.sect4 .left {
  width: 50%;
  margin: 20px 0 250px;
  float: left;
}

.sect4 .left .desp {
  margin: 60px 0 0 20px;
  padding: 40px 170px 40px 40px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  background: #fff;
  box-shadow: 2px 2px 5px #808080;
}

.sect4 .left .desp .tit {
  padding: 7px 30px;
  box-sizing: border-box;
  display: inline-block;
  position: absolute;
  left: -20px;
  top: -20px;
  font-size: 20px;
  color: #fff;
  background: #E99776;
  box-shadow: 2px 2px 5px #808080;
}

.sect4 .right {
  width: 45%;
  float: right;
  position: relative;
}

.sect4 .right .imgContainer4-1 {
  width: 75%;
  position: absolute;
  left: 10%;
}

.sect4 .right .imgContainer4-2 {
  width: 75%;
  position: absolute;
  left: -200px;
  top: 150px;
}

.sect4 iframe {
  width: 700px;
  margin: auto;
  display: block;
  border-radius: 10px;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }

  .sect4 {
    background: radial-gradient(circle at 50% 30%, #FDF8E4, #FDF8E4 77%, #ffffff00 77.1%);
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }

  .sect4 {
    background: radial-gradient(circle at 50% 35%, #FDF8E4, #FDF8E4 80%, #ffffff00 80.1%);
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect3 .sternula .item {  
    flex: 0 0 48%;
  }

  .sect4 .left {
    width: 100%;
    margin: 0 0 0;
  }

  .sect4 .left .desp {
    margin: 40px 0 20px 20px;
    padding: 40px 30px 30px;
  }

  .sect4 .right {
    width: 100%;
  }

  .sect4 .right .imgContainer4-1 {
    width: 40%;
    margin: 10px 5%;
    position: static;
  }

  .sect4 .right .imgContainer4-2 {
    width: 40%;
    margin: 10px 5%;
    position: static;
  }

  .sect4 iframe {
    width: 100%;
    margin: 20px 0 0;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect2 .sectTit {
    width: 320px;
    padding: 10px;
    top: -30px;
    font-size: 20px;
  }

  .sect2 .gallery .left {
    flex: 0 0 100%;
  }

  .sect2 .gallery .right {
    flex: 0 0 100%;
  }

  .sect2 .gallery .right .imgContainer2-2 {
    margin: 5px 0;
  }

  .sect3 .sectTit {
    width: 320px;
    font-size: 20px;
  }

  .sect3 .sternula .item {  
    flex: 0 0 100%;
  }

  .sect4 .left {
    width: 100%;
    margin: 0 0 0;
  }

  .sect4 .left .desp {
    margin: 40px 0 20px 20px;
    padding: 40px 30px 30px;
  }

  .sect4 .right {
    width: 100%;
  }

  .sect4 .right .imgContainer4-1 {
    width: 80%;
    margin: 5px 10%;
    position: static;
  }

  .sect4 .right .imgContainer4-2 {
    width: 80%;
    margin: 5px 10%;
    position: static;
  }

  .sect4 iframe {
    width: 100%;
    margin: 20px 0 0;
  }
}
</style>
